// extracted by mini-css-extract-plugin
export default {"table":"theme_table__PGdYN","summary":"theme_summary__KWhWL","performance":"theme_performance__c-4Fb","list":"theme_list__I5vAU","center":"theme_center__p47kp"};